module.exports = __webpack_public_path__ + "static/fluent-teaching-bubble-e6d0d993d57408e3b1d1f11874b482aa.png";